/**
 * Product Page Functionality
 * Handles variant selection, price updates, image gallery, and add to cart
 */

(function() {
  'use strict';
  
  // Get product data from JSON script tag
  const productDataElement = document.getElementById('product-data');
  if (!productDataElement) {
    console.error('Product data not found');
    return;
  }
  
  const productData = JSON.parse(productDataElement.textContent);
  const productOptions = productData.options || [];
  const variantData = productData.variants || {};
  const isSingleQuantityProduct = productData.isSingleQuantityProduct === true;
  const currency = productData.currency || 'USD';
  const translations = productData.translations || {};
  
  // Image gallery functionality
  function changeMainImage(newImageUrl) {
    const mainImage = document.getElementById('main-product-image');
    if (mainImage && newImageUrl) {
      // Preload the image to ensure crisp rendering
      const img = new Image();
      img.onload = function() {
        mainImage.src = newImageUrl;
        mainImage.style.imageRendering = 'auto';
      };
      img.src = newImageUrl;
    }
  }
  
  // Quantity controls
  function changeQuantity(change) {
    const quantityInput = document.getElementById('quantity');
    const currentQuantity = parseInt(quantityInput.value);
    const newQuantity = currentQuantity + change;
    
    if (newQuantity >= 1) {
      quantityInput.value = newQuantity;
    }
  }
  
  // Format price to currency
  function formatPrice(price) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency
    }).format(price / 100);
  }
  
  // Update product price and availability
  function updateProductInfo(variantId) {
    const variant = variantData[variantId];
    if (!variant) return;

    // Update hidden variant ID input
    const variantIdInput = document.getElementById('variant-id');
    if (variantIdInput) {
      variantIdInput.value = variantId;
    }

    // Update main price
    const priceElement = document.getElementById('product-price');
    if (priceElement) {
      priceElement.textContent = formatPrice(variant.price);
    }

    // Update add to cart button
    const addToCartBtn = document.querySelector('#product-form button[type="submit"]');
    if (addToCartBtn) {
      const addToCartText = translations.addToCart || 'Add to Cart';
      const soldOutText = translations.soldOut || 'Sold Out';
      
      if (variant.available) {
        addToCartBtn.textContent = addToCartText;
        addToCartBtn.disabled = false;
        addToCartBtn.classList.remove('opacity-50', 'cursor-not-allowed');
      } else {
        addToCartBtn.textContent = soldOutText;
        addToCartBtn.disabled = true;
        addToCartBtn.classList.add('opacity-50', 'cursor-not-allowed');
      }
    }
  }
  
  // Find variant based on selected options
  function findVariantByOptions() {
    const selectedOptions = {};
    document.querySelectorAll('.variant-option-select').forEach((select, index) => {
      selectedOptions[index + 1] = select.value;
    });

    // Find matching variant
    for (const [variantId, variant] of Object.entries(variantData)) {
      const variantOptions = Array.isArray(variant.options) ? variant.options : [];
      let matches = true;

      for (const [position, value] of Object.entries(selectedOptions)) {
        if (variantOptions[parseInt(position) - 1] !== value) {
          matches = false;
          break;
        }
      }

      if (matches) {
        return variantId;
      }
    }

    return null;
  }
  
  // Initialize when DOM is ready
  document.addEventListener('DOMContentLoaded', function() {
    const productForm = document.getElementById('product-form');
    if (productForm) {
      productForm.addEventListener('submit', function(e) {
        e.preventDefault();

        const formData = new FormData(this);
        const variantId = formData.get('id');
        const quantity = isSingleQuantityProduct ? 1 : (parseInt(formData.get('quantity')) || 1);

        // Collect properties (checkboxes and text inputs)
        const properties = {};

        // Check each custom option checkbox
        const rubberFeet = document.getElementById('option-rubber-feet');
        if (rubberFeet && rubberFeet.checked) {
          properties['Rubber Feet'] = 'Yes';
        }

        const handles = document.getElementById('option-handles');
        if (handles && handles.checked) {
          properties['Handles'] = 'Yes';
        }

        // Collect engraving text if present
        const engravingInput = document.getElementById('engraving-text');
        if (engravingInput && engravingInput.value.trim()) {
          properties['Engraving Text'] = engravingInput.value.trim();
        }

        // Add to cart with properties
        if (window.cart && window.cart.addItem) {
          window.cart.addItem(variantId, quantity, properties);
        } else if (window.cartDrawer && window.cartDrawer.addToCart) {
          window.cartDrawer.addToCart(variantId, quantity, properties);
        }
      });
    }

    // Handle variant option changes
    const variantSelects = document.querySelectorAll('.variant-option-select');
    variantSelects.forEach(select => {
      select.addEventListener('change', function() {
        // Find and update variant
        const variantId = findVariantByOptions();
        if (variantId) {
          updateProductInfo(variantId);
        }
      });
    });

    // Initialize button state on page load
    // For products with variant selects, find variant based on selected options
    let initialVariantId = null;
    
    if (variantSelects.length > 0) {
      // Try to find variant based on selected dropdown values
      initialVariantId = findVariantByOptions();
    }
    
    // Fallback: use the variant ID from hidden input if not found via options
    if (!initialVariantId) {
      const variantIdInput = document.getElementById('variant-id');
      if (variantIdInput && variantIdInput.value) {
        initialVariantId = variantIdInput.value;
      } else {
        const singleVariantId = document.querySelector('input[name="id"]');
        if (singleVariantId && singleVariantId.value) {
          initialVariantId = singleVariantId.value;
        }
      }
    }
    
    // Update button state with found variant
    if (initialVariantId) {
      updateProductInfo(initialVariantId);
    } else {
      // Last resort: check if product has any available variants
      const addToCartBtn = document.querySelector('#product-form button[type="submit"]');
      if (addToCartBtn) {
        const hasAvailableVariant = Object.values(variantData).some(v => v.available === true);
        if (!hasAvailableVariant) {
          const soldOutText = translations.soldOut || 'Sold Out';
          addToCartBtn.textContent = soldOutText;
          addToCartBtn.disabled = true;
          addToCartBtn.classList.add('opacity-50', 'cursor-not-allowed');
        }
      }
    }
  });
  
  // Expose functions globally for backward compatibility
  window.changeMainImage = changeMainImage;
  window.changeQuantity = changeQuantity;
  
  // Event delegation for product page actions (CSP compliant)
  document.addEventListener('click', function(e) {
    const target = e.target.closest('[data-action]');
    if (!target) return;
    
    const action = target.getAttribute('data-action');
    
    switch (action) {
      case 'change-main-image':
        const fullImage = target.getAttribute('data-full-image');
        if (fullImage) {
          changeMainImage(fullImage);
        }
        break;
      case 'change-quantity':
        const delta = parseInt(target.getAttribute('data-delta'), 10);
        if (!isNaN(delta)) {
          changeQuantity(delta);
        }
        break;
    }
  });
})();
